import { useUser } from './useQueryUser';

export const useSeenModalsCount = (): number => {
  const { data = 0 } = useUser((data) => Object.keys(data?.seen_modals ?? {}).length);
  return data;
};
